import { inject } from '@angular/core';
import { Router, type CanMatchFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { landingPathFor } from '../auth/landing';

function landingUrlTree(auth: AuthService, router: Router) {
  return router.createUrlTree([landingPathFor(auth.role())]);
}

export const publicGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return landingUrlTree(auth, router);
  }

  // We have a token but haven't loaded the user yet (e.g. on a hard refresh
  // before AppComponent's bootstrap() call resolves) — wait for it instead of
  // treating the user as logged out.
  if (auth.hasAccessToken()) {
    return auth.bootstrap().pipe(map((user) => (user ? landingUrlTree(auth, router) : true)));
  }

  return true;
};
